import { useCreationStore } from '../../lib/creationStore'
import { useRefSunsigns } from '../../hooks/useRefData'

const MONTHS = [
  'Nuzyael','Peonu','Kelen','Nolus','Larane','Agrazhar',
  'Azura','Halane','Savor','Ilvin','Navek','Morgat'
]

export function StepBirthday() {
  const store = useCreationStore()
  const { data: sunsigns } = useRefSunsigns()

  return (
    <div>
      <h3>Step 2: Birthday & Sunsign</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.75rem' }}>
        <div>
          <label>Birth Year (TR)</label><br />
          <input type="number" value={store.birth_year}
            onChange={e => store.setField('birth_year', parseInt(e.target.value) || 700)}
            style={{ width: '100%', padding: '0.4rem' }} />
        </div>
        <div>
          <label>Birth Month</label><br />
          <select value={store.birth_month}
            onChange={e => store.setField('birth_month', parseInt(e.target.value))}
            style={{ width: '100%', padding: '0.4rem' }}>
            {MONTHS.map((m, i) => <option key={i} value={i + 1}>{i + 1} — {m}</option>)}
          </select>
        </div>
        <div>
          <label>Birth Day (1–30)</label><br />
          <input type="number" min={1} max={30} value={store.birth_day}
            onChange={e => store.setField('birth_day', parseInt(e.target.value) || 1)}
            style={{ width: '100%', padding: '0.4rem' }} />
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginTop: '0.75rem' }}>
        <div>
          <label>Sunsign</label><br />
          <select value={store.sunsign_id}
            onChange={e => store.setField('sunsign_id', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }}>
            {sunsigns?.sort((a, b) => a.sort_order - b.sort_order).map(s =>
              <option key={s.sunsign_id} value={s.sunsign_id}>{s.display_name} ({s.symbol})</option>
            )}
          </select>
        </div>
        <div style={{ display: 'flex', alignItems: 'end', gap: '0.5rem' }}>
          <label>
            <input type="checkbox" checked={store.on_cusp}
              onChange={e => store.setField('on_cusp', e.target.checked)} />
            {' '}On Cusp
          </label>
        </div>
      </div>
    </div>
  )
}
